(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[190],{

/***/ "jvJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/event-form/EventForm.jsx + 4 modules
var EventForm = __webpack_require__("UAZV");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/lines/event-form-line/EventFormLine.utils.js
var EventFormLine_utils = __webpack_require__("s9tc");

// CONCATENATED MODULE: ./src/client/components/lines/event-form-line/EventFormLine.jsx
var __jsx = react_default.a.createElement;




var EventFormLine_EventFormLine = function EventFormLine(props) {
  Object(i18n["a" /* addTranslationKeys */])({
    eventForm: props
  });
  var formError = props.formError,
      formSuccess = props.formSuccess,
      resorts = props.resorts,
      eventTypeOptions = props.packageSection.eventTypeOptions,
      _props$userSection = props.userSection,
      displayAddressFields = _props$userSection.displayAddressFields,
      salutationOptions = _props$userSection.salutationOptions;
  var formResorts = Object(EventFormLine_utils["b" /* getEventFormResorts */])(resorts);
  var formRegions = Object(EventFormLine_utils["a" /* getEventFormRegions */])(formResorts);
  return __jsx(EventForm["a" /* EventForm */], {
    type: "classic",
    displayAddressFields: displayAddressFields,
    typeOptions: eventTypeOptions,
    formError: formError,
    formSuccess: formSuccess,
    regions: formRegions,
    resorts: formResorts,
    userSalutationOptions: salutationOptions
  });
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/event-form/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (EventFormLine_EventFormLine);

/***/ })

}]);